import HandleSectionsCondition from './HandleSectionsCondition';

export default HandleSectionsCondition;